<template>
  <div id="app">
    <router-view />
    <Toaster :dataValue="toasterData" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Toaster from "./components/common/Toaster";

export default {
  name: 'App',
  components: {
    Toaster
  },
  data() {
    return {
      isDisconnected: false,
      toasterData: {},
      Interval: null,
      timeLeft: null
    }
  },
  computed: {
      ...mapState(['maxMinuteForcall'])
  },
  methods:{},
  mounted() {
    this.$socket.on('connect', () => {
      console.log('--connect---')
      console.log('=this.$cookie.get(DisconnectingStatus),==',this.$cookie.get('DisconnectingStatus'))
       var disconnectVal = this.$cookie.get('DisconnectingStatus')
       console.log('==disconnectVal==',disconnectVal)
       setTimeout(()=>{
          this.$socket.emit("connection_established", {
          disconnect: disconnectVal,   
          x_auth_token:
            this.$cookie.get('X-Auth-Token') == null
              ? ''
              :  this.$cookie.get('X-Auth-Token'),
          user_id:  this.$cookie.get('X-Auth-Id'),
          identifier: '91',
        })
       },3000)
    })
    this.$socket.on('reconnect', () => {
         this.toasterData = {
              status: true,
              msg: "Back Online",
              timeoutMs: "5000",
              color: "#330028"
        };
    })

    this.$socket.on('disconnect', () => {
      console.log('==netOnOff==',this.$store.state.netOnOff)
      console.log('==disconected===')
      this.$socket.on('reconnect_attempt', () => {
      // var localvar = this.$store.state && this.$store.state.disconnection
      // disconnect:  this.$cookie.get('DisconnectingStatus'),
      this.$socket.io.opts.query = {
        reconnect: 'true',
        x_auth_token:
          this.$cookie.get('X-Auth-Token') == null
            ? ''
            : this.$cookie.get('X-Auth-Token'),
        identifier: '91',
        user_id: this.$cookie.get('X-Auth-Id')
      }
    });
    })

    window.addEventListener('online', (e) => {
        this.$store.commit('Internet',true)
        this.toasterData = {
              status: true,
              msg: "online",
              timeoutMs: "5000",
              color: "#330028"
        };
    });
    window.addEventListener('offline', (e) => { 
        this.$store.commit('Internet',false)
        this.toasterData = {
              status: true,
              msg: "offline",
              timeoutMs: "5000",
              color: "#330028"
        };
    });
    navigator.connection.addEventListener("change", (e) => {
     if(navigator.connection.downlink > 0 && navigator.connection.downlink < 1){
           this.toasterData = {
              status: true,
              msg: "Your Internet Connection is slow",
              timeoutMs: "5000",
              color: "#330028"
        };
      }
    });
  }
}
</script>

